module.exports = __webpack_public_path__ + "static/media/and_onboarding_enable_kbd.322537d0.png";